import React from 'react';
import ScrollMenu from 'react-horizontal-scrolling-menu';
import PrevArrow from '../slider_components/slider_prev_arrow/PrevArrow';
import NextArrow from '../slider_components/slider_next_arrow/NextArrow';
import './ScrollMenu.css';

const MenuItem = ({text, selected, currQuesData}) => {
  let classes = selected ? ' active' : '';
  if (currQuesData !== '') {
    if (currQuesData.user_answer !== null && currQuesData.user_answer.length > 0) {
      classes += currQuesData.success ? ' correct' : ' incorrect';
    }
    classes += currQuesData.is_reviewed ? ' reviewed' : '';
  }
  return <div className={`menu-item${classes}`}>{text}</div>;
};

class TestExplanationScrollMenu extends React.PureComponent {
  state = {
    selected: '',
  };

  componentDidMount() {
    const {data, responseData, filterValue} = this.props;
    this.menuItems = this.buildMenu(data, data[0], responseData, filterValue);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.filterValue !== nextProps.filterValue) {
      const {data, responseData, filterValue} = nextProps;
      this.menuItems = this.buildMenu(data, data[0], responseData, filterValue);
    }
  }

  buildMenu = (list, selected, responseData, filterValue) =>
      list.map((el, index) => {
        return (
            <MenuItem
                key={responseData[list[index]].question_id}
                text={filterValue === 0 ? index + 1 : list[index] + 1}
                selected={selected}
                currQuesData={ responseData[list[index]] === undefined ? '' : responseData[list[index]]
                }
            />
        );
      });

  render() {
    const {selectedQuestionId, changeQuestion} = this.props;
    const menu = this.menuItems;

    return (
        <ScrollMenu
            data={menu}
            wheel={false}
            arrowLeft={<PrevArrow size={16}/>}
            arrowRight={<NextArrow size={16}/>}
            selected={selectedQuestionId}
            alignCenter={false}
            onSelect={changeQuestion}
            scrollToSelected={true}
        />
    );
  }
}

export {TestExplanationScrollMenu};
